<template>
  <UiContainer class="verify-email-page">
    <div class="verify-email-page__card-wrap">
      <UiCard class="verify-email-page__card">
        <h1 class="verify-email-page__title">Подтверждение email</h1>

        <p v-if="status === 'loading'" class="verify-email-page__text">Проверяем ссылку...</p>
        <p
          v-else-if="status === 'success'"
          class="verify-email-page__text verify-email-page__text--success"
        >
          {{ message }}
        </p>
        <p v-else class="verify-email-page__text verify-email-page__text--error">{{ message }}</p>

        <div class="verify-email-page__actions">
          <UiButton to="/login">Перейти ко входу</UiButton>
          <UiButton variant="secondary" to="/register">Регистрация</UiButton>
        </div>
      </UiCard>
    </div>
  </UiContainer>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import apiClient from '@/api/client'
import { getApiBaseUrl } from '@/api/base-url'
import UiButton from '@/shared/ui/UiButton.vue'
import UiCard from '@/shared/ui/UiCard.vue'
import UiContainer from '@/shared/ui/UiContainer.vue'

type VerificationStatus = 'loading' | 'success' | 'error'

const route = useRoute()
const status = ref<VerificationStatus>('loading')
const message = ref('Проверяем ссылку...')

onMounted(async () => {
  const token = route.query['token']
  if (typeof token !== 'string' || token.trim().length === 0) {
    status.value = 'error'
    message.value = 'Ссылка подтверждения некорректна'
    return
  }

  try {
    const apiUrl = getApiBaseUrl()
    const { data } = await apiClient.get(`${apiUrl}/api/auth/verify-email`, {
      params: { token: token.trim() },
    })

    status.value = 'success'
    message.value = (data?.message as string | undefined) ?? 'Email успешно подтвержден'
  } catch (error) {
    status.value = 'error'
    message.value = error instanceof Error ? error.message : 'Не удалось подтвердить email'
  }
})
</script>

<style scoped>
.verify-email-page {
  padding-top: 40px;
  padding-bottom: 40px;
}

.verify-email-page__card-wrap {
  max-width: 560px;
  margin: 0 auto;
}

.verify-email-page__card {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.verify-email-page__title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.verify-email-page__text {
  margin: 0;
  font-size: 16px;
  color: #475569;
}

.verify-email-page__text--success {
  color: #166534;
}

.verify-email-page__text--error {
  color: #b91c1c;
}

.verify-email-page__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
